import { useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { onMenuClick } from 'scripts/utils/data-layer'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

const MenuItem = ({ data, trigger }) => {
  const { isBlackWeekend } = useContext(HeaderContext)

  const onItemClick = (event, item) => {
    if (!item.content?.length) {
      event.preventDefault()
      event.stopPropagation()

      onMenuClick({ item, isMobile: true })

      const anchorElement = event.currentTarget.querySelector('a')
      const url = anchorElement.href

      window.location.href = url
    } else {
      trigger()
    }
  }

  const itemClass = classNames('menu-list-mobile-link ', {
    'is-store-menu': data.id === 'stores',
    'is-black-weekend': data.id === 'black-friday' && isBlackWeekend
  })

  return (
    <li
      className="menu-list-mobile-item"
      onClick={event => onItemClick(event, data)}
    >
      {
        data.content && data.content.length > 0
          ? data.name
          : <a className={itemClass} href={data.url}>{ data.name }</a>
      }
    </li>
  )
}

MenuItem.propTypes = {
  data: PropTypes.object.isRequired,
  trigger: PropTypes.func.isRequired
}

export default MenuItem
